export const masks = {
  phone: [
    '+',
    '7',
    ' ',
    '(',
    /[1-9]/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/
  ],
  inn: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
  orgn: [
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/
  ]
};

const getFieldProps = (fieldConfig = {}) => {
  const type = fieldConfig.fieldType || fieldConfig.type;

  switch (type) {
    case 'phone':
      return {
        mask: masks.phone,
        showMask: true,
        guide: true
      };
    case 'inn':
      return {
        mask: masks.inn,
        guide: false
      };
    case 'orgn':
      return {
        mask: masks.orgn,
        guide: false
      };
    default:
      return null;
  }
};

const NormalizeUtils = {
  getFieldProps
};

export default NormalizeUtils;



// WEBPACK FOOTER //
// ./src/utils/normalizeUtils.js